import { defineComponent as _defineComponent } from 'vue'
import { IWithdrawDetailsV2 } from '@/modules/transaction/services/product-withdraw';
import { HeadingDisplay, ListDisplay, Modal } from '@warrenbrasil/nebraska-web';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAvailableForRedemption',
  props: {
    isOpen: { type: Boolean },
    withdrawDetails: null
  },
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  withdrawDetails: IWithdrawDetailsV2;
};



const availableForRedemption = computed(() => [
  {
    title: 'Saldo atual do produto',
    value: props.withdrawDetails.currentBalance
  },
  {
    title: 'Em resgate',
    value: props.withdrawDetails.inRedemption.formatted
  },
  {
    title: 'Aplicações em processamento',
    value: props.withdrawDetails.inProcessing.formatted
  },
  {
    title: 'Saldo disponível para resgate',
    value: props.withdrawDetails.availableToRedemption.formatted
  }
]);

return { __sfc: true,props, availableForRedemption, HeadingDisplay, ListDisplay, Modal }
}

})